import React, { useState, useEffect } from "react";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import CookieConsent, { Cookies } from "react-cookie-consent";
import "./Cookie.css";

export default function Cookie() {
  let userSelectedLanguage = localStorage.getItem("selectedLanguage");
  const [cookieMsg, setCookieMsg] = useState("");

  const [cookieConsent, setCookieConsent] = useState(null);

  useEffect(() => {
    if (userSelectedLanguage == null) {
      userSelectedLanguage = "sw";
    }
    setCookieMsg(TranslationFile.cookiesText[userSelectedLanguage]);

    const consentValue = Cookies.get("RBLCookieConsent");
  }, []);

  return (
    <CookieConsent
      location="bottom"
      buttonText="OK"
      cookieName="RBLCookieConsent"
      buttonStyle={{
        padding: "12px 32px",
        borderRadius: "4px",
        outline: "none",
        fontSize: "14px",
        fontWeight: "500",
        color: "white",
        backgroundColor: "#ff5f00",
        border: "1px solid #ff5f00"
      }}
      expires={150}
      enableDeclineButton
    >
      {cookieMsg}
    </CookieConsent>
  );
}
